var map = {
	"./ArrowLft.svg": "fnuc",
	"./ArrowRt.svg": "NJ04",
	"./ContactArrow.svg": "MQuI",
	"./Facebook.svg": "0RnZ",
	"./Forms.svg": "kqE1",
	"./IG.svg": "FfJK",
	"./Location.svg": "hOR3",
	"./Logo-old-2.svg": "RVkn",
	"./Logo-old.svg": "9FgD",
	"./Logo.svg": "RK8T",
	"./QuoteLft.svg": "kbMS",
	"./QuoteRt.svg": "VPgE",
	"./RequestAppt.svg": "AXNV",
	"./Twit.svg": "9RLL"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UFRR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons ^\.\/.*\.svg$
// module id = UFRR
// module chunks = 2